// Index of the Orders domain.
//
// The sibling dashboards from the same PRD set — Order Fulfillment Dashboard
// and Geographic Order Intelligence — are added here as further entries.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiMapPin, FiPieChart, FiTruck } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import FeatureCardGrid from '../components/FeatureCardGrid';

const DASHBOARDS = [
  {
    id: 'order_analytics',
    title: 'Order Analytics',
    description: 'The shape of the order book: what orders are made of by category and channel, when demand arrives, and how much customers buy per order.',
    icon: <FiPieChart />,
    route: '/dashboard/seller-intelligence/orders/order-analytics',
    action: 'Open →'
  },
  {
    id: 'order_fulfillment',
    title: 'Order Fulfillment Dashboard',
    description: 'What needs shipping right now, what is stuck, and where your cancellation and defect numbers come from.',
    icon: <FiTruck />,
    route: '/dashboard/seller-intelligence/orders/order-fulfillment',
    action: 'Open →'
  },
  {
    id: 'geographic_orders',
    title: 'Geographic Order Intelligence',
    description: 'What delivery speed each part of India is promised, split by who ships it and traced back to the fulfilment centre serving that region.',
    icon: <FiMapPin />,
    route: '/dashboard/seller-intelligence/orders/geographic',
    action: 'Open →'
  }
];

const OrdersHub = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Orders</h1></div>
          <p>What your order book is made of, and what happens to it</p>
        </div>
      </div>
      <div className={styles.content}>
        <FeatureCardGrid items={DASHBOARDS} />
      </div>
    </div>
  );
};

export default OrdersHub;
